import { Grid as MuiGrid } from '@mui/material';

export function Grid(props) {
  const { columns = 1, ...passThroughProps } = props;

  return (
    <MuiGrid container {...passThroughProps}>
      {[props.children]
        .flat()
        .filter(Boolean)
        .map((child, i) => (
          <MuiGrid item key={i} xs={12 / columns}>
            {child}
          </MuiGrid>
        ))}
    </MuiGrid>
  );
}
